// Ocultar categorías que contengan DESTACADOS
(function() {
  function hideDestacadosCategories() {
    // Buscar todos los elementos de categorías/filtros
    const categoryElements = document.querySelectorAll('.nov-sidebar a, .nov-sidebar li, .sidebar-filter a, .sidebar-filter li, .filter-item, .category-item');

    categoryElements.forEach(function(element) {
      const text = element.textContent || element.innerText || '';
      const href = element.getAttribute('href') || '';

      // Si el texto o el href contiene DESTACADOS (en cualquier variación)
      if (text.toUpperCase().includes('DESTACADO') || href.toUpperCase().includes('DESTACADO')) {
        // Ocultar el elemento
        element.style.display = 'none';

        // Si es un link, ocultar también su contenedor padre (li)
        if (element.tagName === 'A' && element.parentElement) {
          element.parentElement.style.display = 'none';
        }
      }
    });
  }

  // Ejecutar cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideDestacadosCategories);
  } else {
    hideDestacadosCategories();
  }

  // También ejecutar después de un pequeño delay por si hay contenido que se carga dinámicamente
  setTimeout(hideDestacadosCategories, 500);
  setTimeout(hideDestacadosCategories, 1500);
})();